export default [
    {
        path: '/postulacion',
        /* meta: { nombre: 'Metricas' }, */
        name: 'registroPostulacion',
        component: () => import(/* webpackChunkName: "informacion" */ '../../pages/registroPostulacion/registroPostulacion').then(m => m.default || m),
    }
]
